import React from 'react';

interface SectionLabelProps {
  /** Indice da secao (1, 2, 3 ...). Renderizado com zero a esquerda. */
  index: number;
  title: string;
  /** Texto secundario alinhado a direita (helper, ex: "8+ caracteres"). */
  sub?: string;
}

/**
 * Cabecalho numerado de secao no signup desktop. Renderiza
 *   "01  Voce" + sub opcional a direita
 *
 * Origem: templates/Login com Google/src/desktop-signup.jsx <SectionLabel>.
 */
export function SectionLabel({ index, title, sub }: SectionLabelProps) {
  return (
    <div className="auth-section-label">
      <span className="auth-section-label__index">
        {index.toString().padStart(2, '0')}
      </span>
      <h3 className="auth-section-label__title">{title}</h3>
      {sub && <span className="auth-section-label__sub">{sub}</span>}
    </div>
  );
}
